// extracted by mini-css-extract-plugin
module.exports = {"content":"register_content__1Gffm","action":"register_action__cImyr"};